import React from 'react';
import TopBar from '../components/TopBar';
import Footer from '../components/Footer';

function BillOfRights() {
  return (
    <div className="App">
      <TopBar />
      <div style={{ 
        padding: '120px 24px 48px 24px',
        maxWidth: '1200px',
        margin: '0 auto'
      }}>
        <h1 style={{ color: '#004080', marginBottom: '32px' }}>Client Bill of Rights</h1>
        
        <section style={{ marginBottom: '32px' }}>
          <h2 style={{ color: '#004080', marginBottom: '16px' }}>Your Rights as a Client</h2>
          <p style={{ marginBottom: '16px', lineHeight: '1.6' }}>
            As a client of Connection Health Care, you have the right to:
          </p>
          <ul style={{ marginBottom: '16px', lineHeight: '1.6' }}>
            <li>Be treated with dignity and respect</li>
            <li>Receive care without discrimination</li>
            <li>Make informed decisions about your care</li>
            <li>Privacy and confidentiality</li>
            <li>Access your health records</li>
            <li>Express concerns without fear of reprisal</li>
          </ul>
        </section>

        <section style={{ marginBottom: '32px' }}>
          <h2 style={{ color: '#004080', marginBottom: '16px' }}>Quality of Care</h2>
          <p style={{ marginBottom: '16px', lineHeight: '1.6' }}>
            You have the right to:
          </p>
          <ul style={{ marginBottom: '16px', lineHeight: '1.6' }}>
            <li>Receive high-quality, professional care</li>
            <li>Know the names and roles of your care providers</li>
            <li>Participate in the development of your care plan</li>
            <li>Refuse treatment, within the limits of the law</li>
          </ul>
        </section>

        <section style={{ marginBottom: '32px' }}>
          <h2 style={{ color: '#004080', marginBottom: '16px' }}>Communication and Information</h2>
          <p style={{ marginBottom: '16px', lineHeight: '1.6' }}>
            You have the right to:
          </p>
          <ul style={{ marginBottom: '16px', lineHeight: '1.6' }}>
            <li>Clear information about your health status</li>
            <li>Explanation of treatment options</li>
            <li>Voice complaints and receive timely responses</li>
            <li>Access support services and resources</li>
          </ul>
        </section>

        <section style={{ marginBottom: '32px' }}>
          <h2 style={{ color: '#004080', marginBottom: '16px' }}>Contact Us</h2>
          <p style={{ marginBottom: '16px', lineHeight: '1.6' }}>
            If you have questions about your rights or wish to report a concern, please contact us at info@connectionhealth.ca
          </p>
        </section>
      </div>
      <Footer />
    </div>
  );
}

export default BillOfRights;
